// Navigation configuration for unified navigation system
export const navigationConfig = {
  // Main navigation links (appears on all variants)
  mainLinks: [
    { path: '/about', label: 'About' },
    { path: '/ourtalents', label: 'Our Talents' },
    { path: '/clients', label: 'Clients' },
    { path: '/careers', label: 'Careers' },
    { path: '/blog', label: "What's New" },
    { path: '/contact', label: 'Contact' }
  ],

  // Home dropdown sections (only for overlay variant and mobile)
  homeDropdown: [
    { name: "About Company", sectionId: "about-company" },
    { name: "Our Service", sectionId: "our-service" },
    { name: "Case Studies", sectionId: "case-studies" },
    { name: "Why Werkix", sectionId: "why-werkix" },
    { name: "Meet Our Team", sectionId: "meet-our-team" },
    { name: "Talent Testimonies", sectionId: "talent-testimonies" },
    { name: "Clients Testimonials", sectionId: "clients-testimonials" },
    { name: "Blog & Articles", sectionId: "blogs-articles" }
  ],

  // Join Us button configuration
  joinButton: {
    path: '/ourtalents',
    label: 'Join Us',
    // Show only on home page (overlay variant) and mobile
    showOnOverlay: true,
    showOnHeader: false,
    showOnMobile: true
  },

  // Logo configuration
  logo: {
    src: "https://res.cloudinary.com/dhbe6wtod/image/upload/v1728482531/werkix/logos/high%20resolution%20logos/werkix_new_logo01_oqznwr.png",
    alt: "werkix logo",
    // Show only on overlay variant (home/careers)
    showOnOverlay: true,
    showOnHeader: false,
    showOnMobile: false
  }
};